/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Input, InputGroup, InputRightElement, InputLeftElement, FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import './style.css';
import { ChevronDownIcon } from "../../../Assets/images/svgs";
import { useDebounce } from '../../../Hooks/index'
import PropTypes from "prop-types";

const AutoComplete = ({ options = [], isSearchable = true, label, labelClassName, placeholder, inputName, className, onChange, leftElement, rightElement, errMessage, inputCover, autoCompleteClassName, value = "", note, isRequired }) => {
  const initialOptionState = { label: "", value: "" };
  const [searchValue, setSearchValue] = useState('');
  const [selectedOption, setSelectedOption] = useState(initialOptionState);
  const [focus, setFocus] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [, debounceSearch] = useDebounce(searchHandler, 300);
  const inputRef = useRef(null);


  useEffect(() => {
    setFilteredOptions(options);

    if (options.length && value)
      setSelectedOption(getOption(options, value) || initialOptionState );
    else
      setSelectedOption(initialOptionState);
  }, [options, value]);

  const getOption = (options, value) => {
    return options.find((e) => {
      if (e.value === value || (!isNaN(value) && e.value === +value))
        return true;
      return false;
    });
  };

  const onSelect = (value) => {
    const selectedOpt = getOption(filteredOptions, value);
    setSelectedOption(selectedOpt);

    if (typeof onChange === 'function')
      onChange(value, selectedOpt);

    if (inputRef.current)
      inputRef.current.blur();
  };

  function searchHandler(searchText) {
    const filtered = options.filter(option =>
      option.label.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredOptions(filtered);
  };

  const selectOptionHandler = (e) => {
    e.preventDefault();
    onSelect(e.target.dataset.value);
  }

  const inputProps = {
    placeholder: placeholder,
    readOnly: !isSearchable,
    value: focus && isSearchable ? searchValue : selectedOption.label,
    ref: inputRef,
    onChange: (e) => {
      setSearchValue(e.target.value);
      debounceSearch(e);
      // Call prop onchange function here
    },
    onFocus: () => {
      setFocus(true);
      // Call prop onfocus function here
    },
    onBlur: () => {
      setFocus(false);
      setSearchValue('');
      setFilteredOptions(options);
      // Call prop onblur function here
    },
    onMouseDown: (e) => {
      if (focus) {
        e.preventDefault();
        inputRef.current.blur();
      }
    },
  };

  return (
    <FormControl className={`autocomplete-field-form-control ${autoCompleteClassName}`} isInvalid={errMessage} isRequired={isRequired}>
      {label && <FormLabel className={`autocomplete-field-label ${labelClassName}`} >{label}</FormLabel>}

      <div className={`autocomplete-custom-cover ${inputCover}`}>
        <InputGroup>
          {leftElement ? (
            <InputLeftElement pointerEvents="none" children={`${leftElement || ""}`} className="input-left-elem" />
          ) : null}

          <Input
            type="text"
            name={inputName}
            className={className}
            errorBorderColor="#FF4242"
            {...inputProps}
          />

          <InputRightElement pointerEvents="none" children={rightElement || <ChevronDownIcon />} className="autocomplete-input-right-elem" />
        </InputGroup>

        {
          focus &&
          <div className={'autocomplete_option_container'} style={{ top: inputRef.current.offsetHeight }}>
            {
              filteredOptions.length ?
                <Options
                  onMouseDown={selectOptionHandler}
                  options={filteredOptions}
                  selectedOption={selectedOption.value}
                /> :
                <div className="autocomplete_option_not_found" >
                  No Options found
                </div>
            }
          </div>
        }
        {(!errMessage && note && !focus) ? <span className='autocomplete-note' style={{ top: inputRef.current ? inputRef.current.offsetHeight + 5 : 0}}>{note}</span> : null}
        <FormErrorMessage className="form-error-message">{errMessage}</FormErrorMessage>
      </div>
    </FormControl>
  )
};

AutoComplete.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  inputName: PropTypes.string,
  rightElement: PropTypes.any,
  leftElement: PropTypes.any,
  autoCompleteClassName: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  errMessage: PropTypes.string,
  inputCover: PropTypes.string,
};

const Options = ({ onMouseDown, options, selectedOption }) => {
  return (
    <div onMouseDown={onMouseDown} >
      {options.map((option, idx) => (
        <Option
          key={idx}
          selected={option.value === selectedOption}
          option={option}
          label={option.label}
          value={option.value}
        />
      ))}
    </div>
  )
};

const Option = ({ selected, label, value }) => {
  const selectedCls = selected ? "autocomplete_option_selected" : '';
  const className = `autocomplete_option_item ${selectedCls}`;
  return (
    <div className={className} data-value={value} tabIndex={-1}>
      {label}
    </div>
  )
};

export default AutoComplete;